import { Application, modulePage } from "../../../../../../../../resources/ts/core/Application";
import { search } from "../../../../../../../../resources/ts/website/components/Search";
import { Recaptcha } from "../../../../../../../../resources/ts/website/components/Recaptcha";
import { helper } from "../../../../../../../../resources/ts/core/Helper";
import { Newsletter } from "../../../../../../../../resources/ts/website/components/Newsletter";
import { Modal } from "bootstrap";

class Main implements modulePage {
    readonly name: string = "Main";

    private documentEvents = () => {
        search.init();
    }

    private cookiePopup() {
        if (helper.getCookie('accept-cookies') === "") {
            const cookiePopup = document.getElementById('cookie-popup') as HTMLLinkElement;
            const cookieLink = document.getElementById('cookie-accept') as HTMLLinkElement;

            cookiePopup.classList.remove("d-none");

            cookieLink.addEventListener('click', (e) => {
                e.preventDefault();
                helper.setCookie('accept-cookies', (new Date()).toString(), 365);
                cookiePopup.classList.add("d-none");
                this.marketingPopup();
            });
        }
    }

    private marketingPopup() {
        if (helper.getCookie('newsletter-shown') === "" && helper.getCookie('accept-cookies') !== "") {
            helper.setCookie('newsletter-shown', (new Date()).toString(), 15);
            setTimeout(() => {
                const modalItem = document.getElementById("newsletterModal");
                if (modalItem) {
                    const modal = Modal.getOrCreateInstance(modalItem);
                    modal.show();
                }
            }, 5000);
        }
    }

    private clock = () => {

        const clock = document.getElementById('clock') as HTMLLinkElement;
        
        const date = new Date();
        const daysOfWeek = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
        const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

        const dayOfWeek = daysOfWeek[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        // const seconds = date.getSeconds().toString().padStart(2, '0');

        clock.innerHTML = `${dayOfWeek}<br>${day} ${month} ${year}, ${hours}:${minutes}`;
    }

    init = () => {
        this.documentEvents();
        this.cookiePopup();
        this.marketingPopup();
        
        this.clock();
        setInterval(() => {
            this.clock();
        }, 1000);
    };

}

document.addEventListener("DOMContentLoaded", function () {
    window.app = window.app ?? new Application();
    window.app.addModules([new Main(), new Recaptcha(), new Newsletter()]);
    window.app.start();
});